var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllgemeinesZivilrecht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.08 151.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00355b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.05,145.49c.04.35.04,1.11,0,1.46-.52,4.34-6.19,6.37-9.34,3.34l-31.22-30.33,7.92-7.74,31.24,30.24c.64.77,1.29,2.02,1.41,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.05,70.86c-1.99-1.71-9.19-9.13-10.72-10.71-.19-.2-.43-.34-.69-.4-6.86-1.7-13.58,3.24-12.59,10.11.05.33-5.45,5.27-5.84,5.57l-22.48,22.48c-.3.39-.62.77-.92,1.17-.16.22-3.64,3.69-3.76,3.78-.27.2-1.53,0-2,0-8,0-12,8-9,14l27,27-60.29.73C2.05,144.86.05,143.86,0,134.53V10.08C.05.86,1.05-.14,10.07.01h59.88c1.19.08,2.33.59,3.23,1.36l36.66,36.66c.48.57,1.35,2.09,1.35,2.82l-.15,30ZM100.56,44.45L66.76,10.66v29.15c0,2.55,2.09,4.64,4.64,4.64h29.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.94 75.47 111.19 97.65 80.02 127.89 57.77 105.72 88.94 75.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.74,107.24c1.63-.2,3.15.23,4.41,1.27l23.15,23.16c3.85,5.26-2.35,11.69-7.71,7.92l-23.06-22.94c-3.12-3.18-1.22-8.87,3.21-9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.49,62.7c1.27-.12,2.48.2,3.56.86,8,7.48,15.55,15.47,23.37,23.15,4.6,5.38-1.74,12.21-7.39,8.33l-23.27-23.26c-2.82-3.38-.65-8.68,3.73-9.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllgemeinesZivilrecht);
export default __webpack_public_path__ + "static/media/AllgemeinesZivilrecht.ad8f894a570430d0171a73af8420f620.svg";
export { ForwardRef as ReactComponent };